<template>
  <div id="survey-add-update">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card" style="margin-bottom: 9px">
              <div class="card-body">
                <input
                  autocomplete="false"
                  name="hidden"
                  type="text"
                  style="display: none"
                />

                <div class="row">
                  <div class="form-group col-md-6">
                    <label>{{ this.$t("event.table.title") }}</label>
                    <el-input
                      v-model="form.title"
                      :class="$inputError('title', validationErrors)"
                    ></el-input>
                    <span class="error">
                      {{ $errorMessage("title", validationErrors) }}
                    </span>
                  </div>
                  <div class="form-group col-md-6">
                    <el-alert
                      :title="$t('event.tags.secretSurvey')"
                      :type="form.isHidden ? 'success' : 'warning'"
                      :closable="false"
                      :description="$t('secretDesc')"
                      :show-icon="false"
                    >
                      <div slot="title">
                        <p style="color: rgb(3, 101, 140); font-size: 16px">
                          {{ this.$t("event.tags.secretSurvey") }}
                        </p>
                        <el-switch
                          v-model="form.isHidden"
                          :active-text="$t('event.variables.yes')"
                          :inactive-text="$t('event.variables.no')"
                        ></el-switch>
                      </div>
                    </el-alert>
                  </div>
                </div>

                <div class="row">
                  <div
                    class="col-md-12"
                    style="
                      margin-bottom: 5px;
                      display: flex;
                      align-items: center;
                      flex-direction: row;
                      justify-content: space-between;
                      border-bottom: 2px solid whitesmoke;
                    "
                  >
                    <h4 style="margin: 0">
                      {{ this.$t("event.tags.questions") }}
                    </h4>
                    <el-button
                      @click="addQuestion"
                      size="mini"
                      type="primary"
                      >{{ $t("event.tags.addQuestion") }}</el-button
                    >
                  </div>
                  <div class="col-md-12" style="margin-bottom: 15px">
                    <draggable
                      handle=".handle2"
                      class="list-group"
                      tag="ul"
                      v-model="form.questions"
                      v-bind="dragOptions"
                      @start="drag = true"
                      @end="drag = false"
                    >
                      <div
                        class="list-group-item card"
                        v-for="(element, index) in form.questions"
                        :key="index"
                        style="margin-bottom: 20px"
                      >
                        <div
                          style="
                            width: 100%;
                            display: flex;
                            flex-direction: row;
                          "
                        >
                          <div
                            style="
                              width: 50px;
                              height: 50px;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              cursor: grab;
                            "
                            class="handle2"
                          >
                            <i class="el-icon-rank" style="font-size: 20px"></i>
                          </div>
                          <span
                            style="
                              font-weight: bold;
                              display: inline-block;
                              margin-right: 5px;
                              width: 50px;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            "
                            >{{ index + 1 }}.</span
                          >
                          <div
                            style="
                              display: flex;
                              flex: 1;
                              flex-direction: column;
                            "
                          >
                            <el-input
                              v-model="form.questions[index].title"
                              :placeholder="$t('writeQuestion')"
                            ></el-input>
                            <span class="error">
                              {{
                                $errorMessage(
                                  "questions[" + index + "].Title",
                                  validationErrors
                                )
                              }}
                            </span>
                          </div>

                          <el-select
                            style="margin-left: 10px; width: 250px"
                            v-model="form.questions[index].type"
                            placeholder="Soru Tipi"
                          >
                            <el-option
                              v-for="item in $enums.questionType"
                              :key="item.value"
                              :label="item.title"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                          <i
                            style="
                              cursor: pointer;
                              display: inline-block;
                              margin-left: 10px;
                            "
                            class="fas fa-trash el-input__icon"
                            slot="suffix"
                            @click="deleteQuestion(index)"
                          ></i>
                        </div>
                        <div
                          style="
                            width: 90%;
                            margin: 20px 70px;
                            box-sizing: border-box;
                            background-color: whitesmoke;
                            padding: 10px;
                          "
                          v-if="element.type != 1"
                        >
                          <div
                            style="
                              width: 100%;
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            "
                          >
                            <span>{{ $t("optionList") }}</span>
                            <el-button
                              type="success"
                              @click="addAnswer(index)"
                              size="mini"
                              >{{ $t("addOption") }}</el-button
                            >
                          </div>
                          <div
                            v-for="(answer, answerIndex) in element.answers"
                            :key="answerIndex"
                            style="
                              display: flex;
                              margin-top: 5px;
                              flex-direction: row;
                              align-items: center;
                            "
                          >
                            <el-input
                              v-model="
                                form.questions[index].answers[answerIndex]
                              "
                              :placeholder="
                                answerIndex + 1 + '. seçeneğinizi buraya yazın.'
                              "
                            ></el-input>
                            <i
                              style="
                                cursor: pointer;
                                display: inline-block;
                                margin-left: 10px;
                              "
                              class="fas fa-trash el-input__icon"
                              slot="suffix"
                              @click="deleteAnswer(index, answerIndex)"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </draggable>
                  </div>
                  <div
                    v-if="form.questions.length > 1"
                    class="col-md-12"
                    style="
                      margin-bottom: 5px;
                      display: flex;
                      align-items: center;
                      flex-direction: row;
                      justify-content: flex-end;
                    "
                  >
                    <el-button
                      @click="addQuestion"
                      size="mini"
                      type="primary"
                      >{{ $t("event.tags.addQuestion") }}</el-button
                    >
                  </div>
                </div>

                <div
                  class="col-md-12"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0;
                  "
                >
                  <div v-if="form.id != null">
                    <el-popconfirm
                      @confirm="deleteItem"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.buttons.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('event.textbox.toDelete')"
                    >
                      <el-button
                        slot="reference"
                        type="danger"
                        icon="fas fa-trash"
                        >{{ $t("event.table.delete") }}</el-button
                      >
                    </el-popconfirm>
                  </div>
                  <div
                    class="text-right"
                    style="
                      display: flex;
                      flex: 1;
                      align-items: center;
                      justify-content: flex-end;
                    "
                  >
                    <el-button-group>
                      <el-button
                        type="warning"
                        @click="
                          $emit('closeMe');
                          showInfo = false;
                        "
                        >{{ $t("event.buttons.close") }}</el-button
                      >
                      <el-button type="success" @click="save">{{
                        $t("event.buttons.save")
                      }}</el-button>
                    </el-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="form.id != null"
      @click="showInfo = !showInfo"
      style="
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 10px 0px;
      "
    >
      <i :class="!showInfo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
    <transition name="slide-fade">
      <ItemInfo :data="form" v-if="showInfo" />
    </transition>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import axios from "axios";
import ItemInfo from "./ItemInfo";
import GroupAddUpdate from "./GroupAddUpdate";
export default {
  components: { ItemInfo, GroupAddUpdate, draggable },
  name: "PollAddUpdate",
  props: ["data"],
  data() {
    return {
      form: {
        id: null,
        title: null,
        orderNO: 1,
        isHidden: false,
        questions: [],
      },
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      addGroupModal: false,
      drag: false,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  mounted() {},
  methods: {
    deleteAnswer(index, answerIndex) {
      this.form.questions[index].answers.splice(answerIndex, 1);
    },
    addAnswer(index) {
      this.form.questions[index].answers.push(null);
    },
    addQuestion() {
      this.form.questions.push({
        id: null,
        title: null,
        orderNO: 0,
        type: 1,
        answers: [],
      });
    },
    deleteQuestion(index) {
      this.form.questions.splice(index, 1);
    },
    async itemAdded(id) {
      this.addGroupModal = false;
      await this.$store.dispatch("getGroups");
      this.form.groupID = id;
    },
    deleteItem() {
      var index = this.$store.state.polls.items.findIndex(
        (k) => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
    save() {
      this.validationErrors = [];
      var i = 1;
      this.form.questions.map((item, index) => {
        this.form.questions[index].orderNO = i;
        i = i + 1;
      });

      axios.post("survey/addorupdate", this.form).then((res) => {
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          if (this.form.id == null) {
            this.$emit("itemAdded");
            this.form = {
              id: null,
              title: null,
              orderNO: 1,
              isHidden: false,
              questions: [],
            };
          } else {
            this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
            if (this.showInfo) {
              this.showInfo = false;
              setTimeout(() => {
                this.showInfo = true;
              }, 350);
            }
          }
        }
      });
    },
  },
  watch: {
    data: function (newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        this.form = this.data;
        this.validationErrors = [];
      } else {
        this.form = {
          id: null,
          title: null,
          orderNO: 1,
          isHidden: false,
          questions: [],
        };
      }
    },
    "form.groupID": function (newVal) {
      if (newVal == -1) {
        this.form.groupID = null;
        this.addGroupModal = true;
      }
    },
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = this.data;
    }
  },
};
</script>
<style>
.flip-list-move {
  transition: transform 0.5s;
}
</style>

<style scoped>
.list-group {
  background: none;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/SurveyAddUpdate.vue